type JerseySwiperInstance = {
  destroy: (deleteInstance?: boolean, cleanStyles?: boolean) => void;
};

type JerseySwiperConstructor = new (element: Element, options: Record<string, unknown>) => JerseySwiperInstance;

declare const Swiper: JerseySwiperConstructor;

const root = document.querySelector<HTMLElement>(".p-jersey2509");

const initMainSliders = (): void => {
  if (!root || typeof Swiper === "undefined") return;

  root.querySelectorAll<HTMLElement>(".js-item-area_swiper").forEach((element) => {
    if (element.querySelectorAll(".swiper-slide").length < 2) return;

    new Swiper(element, {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 25,
      speed: 1000,
      autoHeight: true,
      effect: "fade",
      autoplay: {
        disableOnInteraction: false,
        delay: 6000,
      },
      navigation: {
        nextEl: element.querySelector(".swiper-button-next-main"),
        prevEl: element.querySelector(".swiper-button-prev-main"),
      },
    });
  });
};

const initResponsiveSliders = (): void => {
  if (!root || typeof Swiper === "undefined") return;

  const mediaQuery = window.matchMedia("(max-width: 835px)");
  let collectionSliders: JerseySwiperInstance[] = [];
  let fabricSliders: JerseySwiperInstance[] = [];

  const destroySliders = (sliders: JerseySwiperInstance[]): void => {
    sliders.forEach((slider) => slider.destroy(true, true));
  };

  const updateSliders = (): void => {
    if (!mediaQuery.matches) {
      destroySliders(collectionSliders);
      destroySliders(fabricSliders);
      collectionSliders = [];
      fabricSliders = [];
      return;
    }

    if (collectionSliders.length === 0) {
      collectionSliders = Array.from(root.querySelectorAll<HTMLElement>(".js-item-area_collection-swiper")).map(
        (element) =>
          new Swiper(element, {
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 20,
            speed: 1000,
            effect: "fade",
            autoplay: {
              disableOnInteraction: false,
              delay: 6000,
            },
            pagination: {
              el: element.parentElement?.querySelector(".swiper-pagination-collection"),
            },
            navigation: {
              nextEl: element.parentElement?.querySelector(".swiper-button-next-collection"),
              prevEl: element.parentElement?.querySelector(".swiper-button-prev-collection"),
            },
          }),
      );
    }

    if (fabricSliders.length === 0) {
      fabricSliders = Array.from(root.querySelectorAll<HTMLElement>(".js-item-area_fabric-swiper")).map(
        (element) =>
          new Swiper(element, {
            loop: true,
            slidesPerView: 1.1,
            centeredSlides: true,
            spaceBetween: 20,
            speed: 1000,
            effect: "fade",
            autoplay: {
              disableOnInteraction: false,
              delay: 6000,
            },
            pagination: {
              el: element.parentElement?.querySelector(".swiper-pagination-fabric"),
              type: "fraction",
            },
            navigation: {
              nextEl: element.parentElement?.querySelector(".swiper-button-next-fabric"),
              prevEl: element.parentElement?.querySelector(".swiper-button-prev-fabric"),
            },
          }),
      );
    }
  };

  updateSliders();

  if ("addEventListener" in mediaQuery) {
    mediaQuery.addEventListener("change", updateSliders);
  } else {
    mediaQuery.addListener(updateSliders);
  }
};

const initAnchorLinks = (): void => {
  if (!root) return;

  root.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (event) => {
      const href = anchor.getAttribute("href");
      if (!href) return;

      const id = href.slice(1);
      const element = id ? document.getElementById(id) : null;
      const target = href === "#" ? root : element && root.contains(element) ? element : null;
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initMainSliders();
  initResponsiveSliders();
  initAnchorLinks();
});
